/**
 * Check if we are using an iOS device
 */
const getIsIOS = () => {
  return (
    navigator.platform.indexOf('iPhone') !== -1 ||
    navigator.platform.indexOf('iPad') !== -1 ||
    navigator.platform.indexOf('iPod') !== -1
  );
};

export default getIsIOS;
